import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "theme-budget" }
const _hoisted_2 = { class: "legend" }

import { computed } from "vue";
import { formatPrice, formatPercentage } from "@/helpers/utils";
import GraphDonutWithLabel from "./GraphDonutWithLabel.vue";
import TileTitle from "./TileTitle.vue";
import GraphLegendItem from "./GraphLegendItem.vue";
import { DonutDefinition } from "@/helpers/typesDefinition";
import { useI18n } from "vue-i18n";


export default /*@__PURE__*/_defineComponent({
  __name: 'ThemeBudget',
  props: {
    id: {},
    title: {},
    budget: {},
    globalBudget: {},
    consumed: {},
    globalConsumed: {}
  },
  setup(__props: any) {

useI18n({
  useScope: "global",
  inheritLocale: true,
});

const props = __props;

const donutDefinition = computed((): DonutDefinition => {
  const percentageRaw = props.consumed / props.budget;
  const remainingRaw = 1 - percentageRaw;
  const globalPercentageRaw = props.consumed / props.globalBudget;
  const globalRemainingRaw = 1 - globalPercentageRaw;
  const globalConsumptionPercentage = props.globalConsumed / props.globalBudget;

  const color =
    percentageRaw <= 1 ? "var(--color-primary-base)" : "var(--color-danger)";

  const colorLight =
    globalConsumptionPercentage <= 1
      ? "var(--color-primary-light)"
      : "var(--color-red-light)";

  return {
    layers: [
      {
        id: "themeBudget",
        strokeWidth: 4,
        segments: [
          {
            id: "consumed",
            name: props.title,
            color: color,
            percentage: percentageRaw * 100,
            offset: 0,
            subtotal: 0,
          },
          {
            id: "remaining",
            name: props.title,
            color: "var(--color-neutral-base)",
            percentage: remainingRaw * 100,
            offset: remainingRaw * 100,
            subtotal: 0,
          },
        ],
      },
      {
        id: "globalBudget",
        strokeWidth: 2,
        segments: [
          {
            id: "consumedGlobal",
            name: props.title,
            color: colorLight,
            percentage: globalPercentageRaw * 100,
            offset: 0,
            subtotal: 0,
          },
          {
            id: "remainingGlobal",
            name: props.title,
            color: "var(--color-neutral-light)",
            percentage: globalRemainingRaw * 100,
            offset: globalRemainingRaw * 100,
            subtotal: 0,
          },
        ],
      },
    ],
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createVNode(TileTitle, {
      title: __props.title,
      level: 5,
      class: "title"
    }, null, 8, ["title"]),
    _createElementVNode("ul", _hoisted_2, [
      _createVNode(GraphLegendItem, {
        label: _ctx.$t('labels.projectBudget'),
        value: _unref(formatPrice)(__props.budget)
      }, null, 8, ["label", "value"]),
      _createVNode(GraphLegendItem, {
        label: _ctx.$t('labels.consumed'),
        value: _unref(formatPrice)(__props.consumed)
      }, null, 8, ["label", "value"]),
      _createVNode(GraphLegendItem, {
        label: _ctx.$t('labels.remaining'),
        value: _unref(formatPrice)(__props.budget - __props.consumed)
      }, null, 8, ["label", "value"])
    ]),
    _createVNode(GraphDonutWithLabel, {
      "donut-definition": donutDefinition.value,
      labels: [
        {
          name: _ctx.$t('labels.global'),
          value: _unref(formatPercentage)(__props.consumed / __props.globalBudget),
          style: 'small',
        },
        {
          name: _ctx.$t('labels.consumed'),
          value: _unref(formatPercentage)(__props.consumed / __props.budget),
        },
      ],
      class: "chart"
    }, null, 8, ["donut-definition", "labels"])
  ]))
}
}

})